module.exports = {
    computed: {
        /**
         * Get the billable entity.
         */
        billable() {
            if (this.billableType) {
                return this.billableType === 'user' ? this.user : this.team;
            } else {
                return this.user;
            }
        },


        /**
         * Determine if the current billable entity is a user.
         */
        billingUser() {
            return this.billableType && this.billableType === 'user';
        },


        /**
         * Access the global Spark object.
         */
        spark() {
            return window.Spark;
        },
        recordDetailColumnsList() {
            return ['base-bid', 'final-base-bid', 'contract-amount', 'final-contract-amount', 'contract-date', 'login-date', 'gross-margin', 'labor-hours', 'dead-date', 'estimated-contract-date'];
        }
    },
    methods:{
        getToast(time=null){
            return Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: time ?? 3000,
            });
        },
        confirmationToast(title, message, type, showCancelButton = false, confirmButtonText = 'OK'){
            Swal.fire({
                title: title,
                text: message,
                type: type,
                showCancelButton: showCancelButton,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: confirmButtonText,
                closeOnConfirm: true,
            });
        },
        ucwords(string) {
            let newString = '';
            newString = string.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });

            return newString;
        },
        getFieldLabel(labels, slug) {
            if(slug === 'products-&-services'){
                slug = 'products-and-services'
            }
            if(slug === 'lead-from'){
                slug = 'lead-source'
            }
            if(slug === 'status'){
                slug = 'sales-status'
            }
            if(labels && labels.hasOwnProperty(slug)){
                return labels[slug];
            }else{
                return slug.replace(/-/g, ' ').toUpperCase();
            }
        },
        formatERPModuleName(input) {
            return input
                .replace(/-/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase());
        }
    },
    mounted(){
        $('.dropdown-menu:not(.nav-dropdown-menu, .vista-dropdown-menu)').on('mouseleave', () => {
            $('.dropdown-menu').removeClass('show');
            $('.dropdown-menu').attr('style', '');
            $('.dropdown-menu').removeAttr('x-placement');
            $('.dropdown').removeClass('show');
            $('.dropdown-toggle').attr('aria-expanded', 'false');
        });
    }
};
